import api from '../utils/api';

interface ServiceHealth {
  status: 'healthy' | 'degraded' | 'down' | 'unhealthy';
  semaphore: string;
  message?: string;
  responseTime?: number;
  metadata?: Record<string, unknown>;
  details?: Record<string, unknown>;
}

interface SystemHealthResponse {
  status: 'healthy' | 'degraded' | 'down';
  timestamp: string;
  services: {
    redis: ServiceHealth;
    mongodb: ServiceHealth;
    email: ServiceHealth;
    queue: ServiceHealth;
    scheduler: ServiceHealth;
  };
}

export type { ServiceHealth, SystemHealthResponse };

export const healthService = {
  getSystemHealth: async (): Promise<SystemHealthResponse> => {
    const response = await api.get('/health');
    return response.data;
  }
};

export default healthService;
